import { ModalSystemsComponent } from './../modal-systems/modal-systems.component';
import { MatDialog } from '@angular/material/dialog';
import { Component, Directive, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { toArray } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';

@Component({
  selector: 'app-system-development-bar',
  templateUrl: './system-development-bar.component.html',
  styleUrls: ['./system-development-bar.component.scss']
})
export class SystemDevelopmentBarComponent implements OnInit {

  items: any = environment.api.environments;
  isHidden=true;

  urls: string[] = [];
  chave: any = [];
  version: any;
  apiName: any;

  constructor(
    public dialog: MatDialog, 
    public rendered: Renderer2, 
    private elmRef:ElementRef,
    public api: ApiService,
  ) { }

  ngOnInit(): void {
    this.version = environment.version;
    this.apiName = this.api.getEnvironment();

    Object.keys(this.items).map((key) => {
      this.chave.push([key])
    });
  }

  onShow(){
    this.isHidden=!this.isHidden
  }

  setEnvironment(name: any){
    this.api.setEnvironment(name);
    this.apiName = name;
    this.onShow();
    window.location.reload();
  }
}